import { PDFDocument, StandardFonts, rgb } from 'pdf-lib'
import fontkit from '@pdf-lib/fontkit'
import SquareIcon from './../images/square.png';

let drawPDF = async (data) => {
    let size = 6;
    let lineHeight = 6;
    let colorFont = rgb(0, 0, 0);
    let domain = 'http://localhost:3000';
    if(window.location.hostname !== "localhost") {
        domain = window.location.origin;
    }
    let url = `${domain}/Wniosek_do_200000.pdf`;
    if(data.productPrice > 200000) {
        url = `${domain}/Wniosek_pow_200000.pdf`;
    }
    // const url = `${domain}/wniosek-new.pdf`;
    const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())
    const pdfDoc = await PDFDocument.load(existingPdfBytes)
    pdfDoc.registerFontkit(fontkit)
    const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
    //custom font
    const fontBytes = await fetch(`${domain}/subset-Helvetica.ttf`).then(res => res.arrayBuffer())
    const customFont = await pdfDoc.embedFont(fontBytes)
    //end custom font
    const pages = pdfDoc.getPages()
    const firstPage = pages[0]
    const secondPage = pages[1]
    const thirdPage = pages[2]
    const { width, height } = firstPage.getSize()
    //images
    const imageBytes = await fetch(SquareIcon).then((res) => res.arrayBuffer())
    const pngImage = await pdfDoc.embedPng(imageBytes);
    //first page
    //dane rejestrowe wnioskodawcy
    let forI = 2;
    for(let x = 0; x<forI; x++) {
        if(data.productPrice <= 200000) {
            //Pełna nazwa firmy
            if(data.companyInfo) {
                firstPage.drawText(data.companyInfo, {
                    x: 86,
                    y: height - 210,
                    size: size,
                    font: customFont,
                    lineHeight: 6,
                    color: colorFont,
                })
            }
            // //tel
            if(data.companyPhone) {
                firstPage.drawText(data.companyPhone, {
                    x: 86,
                    y: height - 261,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // //www
            if(data.companyWWW && data.companyWWW.length > 0) {
                firstPage.drawText(data.companyWWW, {
                    x: 200,
                    y: height - 261,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // //email
            if(data.companyEmail) {
                firstPage.drawText(data.companyEmail, {
                    x: 120,
                    y: height - 277.5,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // //email
            if(data.emailInvoice) {
                firstPage.drawText(data.emailInvoice, {
                    x: 150,
                    y: height - 295,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // //dodatkowy kod pocztowy
            if(data.additionalPostal) {
                firstPage.drawText(data.additionalPostal, {
                    x: 346,
                    y: height - 346.5,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // //dodatkowe miasto
            if(data.additionalCity) {
                firstPage.drawText(data.additionalCity, {
                    x: 332,
                    y: height - 362.5,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }

            // //dodatkowy Adres
            if(data.additionalAddress) {
                firstPage.drawText(data.additionalAddress, {
                    x: 90,
                    y: height - 362.5,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // //data rozpoczecia dzialalnosci
            if(data.companyCreatedDate.day) {
                firstPage.drawText(data.companyCreatedDate.day, {
                    x: 427,
                    y: height - 211,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // //data rozpoczecia dzialalnosci
            if(data.companyCreatedDate.month) {
                firstPage.drawText(data.companyCreatedDate.month, {
                    x: 444,
                    y: height - 211,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // //data rozpoczecia dzialalnosci
            if(data.companyCreatedDate.year) {
                firstPage.drawText(data.companyCreatedDate.year, {
                    x: 461,
                    y: height - 211,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // //liczba pracownikow
            if(data.employeesNumber) {
                firstPage.drawText(data.employeesNumber, {
                    x: 360,
                    y: height - 227.5,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //branza
            if(data.profession && data.profession.length > 0) {
                firstPage.drawText(data.profession, {
                    x: 366,
                    y: height - 244.5,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //krs/inny rejestr
            if(data.krs && data.krs.length > 0) {
                firstPage.drawText(data.krs, {
                    x: 353,
                    y: height - 261,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // //nip
            if(data.nip) {
                firstPage.drawText(data.nip, {
                    x: 430,
                    y: height - 261,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // //dane osob upowaznionych
            if(data.representatives) {
                for (let x = 0; x < data.representatives.length; x++) {
                    //imie
                    if(data.representatives[x].name) {
                        firstPage.drawText(`${data.representatives[x].name} ${data.representatives[x].surname}`, {
                            x: 75,
                            y: height - 423 - (x * 64),
                            size: size,
                            font: customFont,
                            lineHeight: lineHeight,
                            color: colorFont,
                        })
                    }
                    //pesel
                    if(data.representatives[x].pesel) {
                        for (let i = 0; i < (data.representatives[x].pesel).length; i++) {
                            firstPage.drawText(`${data.representatives[x].pesel[i]}`, {
                                x: 195 + (i * 9),
                                y: height - 423 - (x * 63),
                                size: size,
                                font: customFont,
                                lineHeight: lineHeight,
                                color: colorFont,
                            })
                        }
                    }
                    //obywatelstwo
                    if(data.representatives[x].citizenship) {
                        firstPage.drawText(`${data.representatives[x].citizenship}`, {
                            x: 310,
                            y: height - 423 - (x * 64),
                            size: size,
                            font: customFont,
                            lineHeight: lineHeight,
                            color: colorFont,
                        })
                    }
                    //państwo urodzenia 
                    if(data.representatives[x].countryBirth) {
                        firstPage.drawText(`${data.representatives[x].countryBirth}`, {
                            x: 420,
                            y: height - 423 - (x * 64),
                            size: size,
                            font: customFont,
                            lineHeight: lineHeight,
                            color: colorFont,
                        })
                    }
                    //dokument
                    if(data.representatives[x].document == "Inny (np. karta pobytu)") {
                        firstPage.drawImage(pngImage, {
                            x: 187.2,
                            y: height - 441.5 - (x * 64),
                            width: 3.6,
                            height: 3.6,
                        })
                    }else if(data.representatives[x].document == "Paszport") {
                        firstPage.drawImage(pngImage, {
                            x: 154.8,
                            y: height - 441.5 - (x * 64),
                            width: 3.6,
                            height: 3.6,
                        })
                    }else if(data.representatives[x].document == "Dowód osobisty") {
                        firstPage.drawImage(pngImage, {
                            x: 107.2,
                            y: height - 441.5 - (x * 64),
                            width: 3.6,
                            height: 3.6,
                        })
                    }
                    //dow osobisty seria i nr
                    if(data.representatives[x].id) {
                        for (let i = 0; i < data.representatives[x].id.length; i++) {
                            firstPage.drawText(`${data.representatives[x].id}`, {
                                x: 258,
                                y: height - 441 - (x * 64),
                                size: size,
                                font: customFont,
                                lineHeight: lineHeight,
                                color: colorFont,
                            })
                        }
                    }
                    // //data wydania dowodu
                    if(data.representatives[x].idReleaseDate) {
                        firstPage.drawText(`${data.representatives[x].idReleaseDate}`, {
                            x: 366,
                            y: height - 441.3 - (x * 64),
                            size: size,
                            font: customFont,
                            lineHeight: lineHeight,
                            color: colorFont,
                        })
                    }
                    // //data waznosci dowodu
                    if(data.representatives[x].idExpirationDate) {
                        firstPage.drawText(`${data.representatives[x].idExpirationDate}`, {
                            x: 456,
                            y: height - 441.3 - (x * 64),
                            size: size,
                            font: customFont,
                            lineHeight: lineHeight,
                            color: colorFont,
                        })
                    }
                }
            }
            // //ZOBOWIĄZANIA PUBLICZNOPRAWNE 
            // Zaległości podatkowe - nie
            if(data.taxArrears == "Nie") {
                firstPage.drawImage(pngImage, {
                    x: 226,
                    y: height - 662.3, 
                    width: 3.6,
                    height: 3.6,
                })
            }else if(data.taxArrears == "Tak") {
                // Zaległości podatkowe - tak
                firstPage.drawImage(pngImage, {
                    x: 247,
                    y: height - 662.3, 
                    width: 3.6,
                    height: 3.6,
                })
                // Zaległości podatkowe - kwota
                if(data.taxArrearsPrice) {
                    firstPage.drawText(data.taxArrearsPrice, {
                        x: 392,
                        y: height - 662.3, 
                        size: size,
                        font: customFont,
                        lineHeight: lineHeight,
                        color: colorFont,
                    })
                }
            }
            if(data.ZUSarrears == "Nie") {
                // // Zaległości wobec ZUS - nie
                firstPage.drawImage(pngImage, {
                    x: 226,
                    y: height - 679, 
                    width: 3.6,
                    height: 3.6,
                })
            }else if(data.ZUSarrears == "Tak") {
                // Zaległości wobec ZUS - tak
                firstPage.drawImage(pngImage, {
                    x: 247,
                    y: height - 679.2, 
                    width: 3.6,
                    height: 3.6,
                })
                // Zaległości wobec ZUS - kwota
                if(data.ZUSarrearsPrice) {
                    firstPage.drawText(data.ZUSarrearsPrice, {
                        x: 392,
                        y: height - 679.2, 
                        size: size,
                        font: customFont,
                        lineHeight: lineHeight,
                        color: colorFont,
                    })
                }
            }
            if(data.enforcementProceedings == "Nie") {
                // Czy jest prowadzone postępowanie - nie
                firstPage.drawImage(pngImage, {
                    x: 226,
                    y: height - 695.3, 
                    width: 3.6,
                    height: 3.6,
                })
            }else if(data.enforcementProceedings == "Tak") {
                // Czy jest prowadzone postępowanie - tak
                firstPage.drawImage(pngImage, {
                    x: 247,
                    y: height - 695.3, 
                    width: 3.6,
                    height: 3.6,
                })
                // Czy jest prowadzone postępowanie - kwota
                if(data.enforcementProceedingsPrice) {
                    firstPage.drawText(data.ZUSarrearsPrice, {
                        x: 392,
                        y: height - 695.3, 
                        size: size,
                        font: customFont,
                        lineHeight: lineHeight,
                        color: colorFont,
                    })
                }
            }

            if(data.prevYearRevenuesTwo !== true) {
                // 2020 - przychody/wynik - przychod
                if(data.revenueOldTwo) {
                    secondPage.drawText(data.revenueOldTwo, {
                        x: 153,
                        y: height - 203.3,
                        size: size,
                        font: customFont,
                        lineHeight: lineHeight,
                        color: colorFont,
                    })
                }
                if(data.revenueScoreOldTwo == "Zysk") {
                    // 2020 - przychody/wynik - zysk
                    secondPage.drawImage(pngImage, {
                        x: 287.4,
                        y: height - 203.3,
                        width: 3.6,
                        height: 3.6,
                    })
                }else if(data.revenueScoreOldTwo == "Strata") {
                    // 2020 - przychody/wynik - strata
                    secondPage.drawImage(pngImage, {
                        x: 311.2,
                        y: height - 203.3,
                        width: 3.6,
                        height: 3.6,
                    })
                }
                // 2020 - przychody/wynik - kwota zysku/straty
                if(data.revenueProfitOldTwo) {
                    secondPage.drawText(data.revenueProfitOldTwo, {
                        x: 345,
                        y: height - 203.3,
                        size: size,
                        font: customFont,
                        lineHeight: lineHeight,
                        color: colorFont,
                    })
                }
            }
            
            if(data.prevYearRevenues !== true) {
                // 2021 - przychody/wynik - przychod
                if(data.revenueOld) {
                    secondPage.drawText(data.revenueOld, {
                        x: 153,
                        y: height - 220,
                        size: size,
                        font: customFont,
                        lineHeight: lineHeight,
                        color: colorFont,
                    })
                }
                if(data.revenueScoreOld == "Zysk") {
                    // 2021 - przychody/wynik - zysk
                    secondPage.drawImage(pngImage, {
                        x: 287.4,
                        y: height - 219.5,
                        width: 3.6,
                        height: 3.6,
                    })
                }else if(data.revenueScoreOld == "Strata") {
                    // 2021 - przychody/wynik - strata
                    secondPage.drawImage(pngImage, {
                        x: 311.2,
                        y: height - 219.5,
                        width: 3.6,
                        height: 3.6,
                    })
                }
                // 2021 - przychody/wynik - kwota zysku/straty
                if(data.revenueProfitOld) {
                    secondPage.drawText(data.revenueProfitOld, {
                        x: 345,
                        y: height - 220,
                        size: size,
                        font: customFont,
                        lineHeight: lineHeight,
                        color: colorFont,
                    })
                }
            }

            // // 2022 - przychody/wynik - przychod
            secondPage.drawText(data.revenue, {
                x: 153,
                y: height -239,
                size: size,
                font: customFont,
                lineHeight: lineHeight,
                color: colorFont,
            })
            if(data.revenueScore == "Zysk") {
                // 2022 - przychody/wynik - zysk
                secondPage.drawImage(pngImage, {
                    x: 287.4,
                    y: height -239.2,
                    width: 3.6,
                    height: 3.6,
                })
            }else if(data.revenueScore == "Strata") {
                // 2022 - przychody/wynik - strata
                secondPage.drawImage(pngImage, {
                    x: 311.2,
                    y: height -239.2,
                    width: 3.6,
                    height: 3.6,
                })
            }
            // 2022 - przychody/wynik - kwota zysku/straty
            if(data.revenueProfit) {
                secondPage.drawText(data.revenueProfit, {
                    x: 345,
                    y: height -239,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // // 2022 - przychody/wynik - od
            if(data.revenueFrom) {
                secondPage.drawText(data.revenueFrom, {
                    x: 85,
                    y: height -243.2,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // // 2022 - przychody/wynik - do
            if(data.revenueTo) {
                secondPage.drawText(data.revenueTo, {
                    x: 120,
                    y: height - 243.2,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // wyjaśnienia straty
            secondPage.drawText(`2022 - ${data.revenueLossExplanationOldTwo}`, {
                x: 77,
                y: height - 282,
                size: size,
                font: customFont,
                lineHeight: lineHeight,
                color: colorFont,
            })
            secondPage.drawText(`2023 - ${data.revenueLossExplanationOld}`, {
                x: 77,
                y: height - 292,
                size: size,
                font: customFont,
                lineHeight: lineHeight,
                color: colorFont,
            })
            secondPage.drawText(`2024 - ${data.revenueLossExplanation}`, {
                x: 77,
                y: height - 302,
                size: size,
                font: customFont,
                lineHeight: lineHeight,
                color: colorFont,
            })

            // checkAndLossAmortizationOld, checkAndLossAmortizationTypeOld, profitFromSalesOld
            if(data.checkAndLossTo) {//date
                secondPage.drawText(data.checkAndLossTo, {
                    x: 263,
                    y: height - 342,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            if(data.checkAndLossTo) {//date
                secondPage.drawText(data.checkAndLossTo, {
                    x: 497,
                    y: height - 342,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            if(data.checkAndLossAmortizationOld) {
                secondPage.drawText(data.checkAndLossAmortizationOld, {
                    x: 165,
                    y: height - 360,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            if(data.profitFromSalesOld) {
                secondPage.drawText(`${data.checkAndLossAmortizationTypeOld == "Zysk" ? "+" : "-" }${data.profitFromSalesOld}`, {
                    x: 400,
                    y: height - 360,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //checkAndLossAmortization, checkAndLossAmortizationTypeOldTwo, profitFromSales
            if(data.checkAndLossAmortization) {
                secondPage.drawText(data.checkAndLossAmortization, {
                    x: 233,
                    y: height - 360,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            if(data.profitFromSales) {
                secondPage.drawText(`${data.checkAndLossAmortizationTypeOldTwo == "Zysk" ? "+" : "-" }${data.profitFromSales}`, {
                    x: 465,
                    y: height - 360,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //bilans
            //Aktywa trwałe
            if(data.balanceTo) { //date
                secondPage.drawText(data.balanceTo, {
                    x: 263,
                    y: height - 400.5,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            if(data.balanceTo) { //date
                secondPage.drawText(data.balanceTo, {
                    x: 497,
                    y: height - 400.5,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            if(data.balanceFixedAssetsOld) {
                secondPage.drawText(data.balanceFixedAssetsOld, {
                    x: 165,
                    y: height - 418,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            if(data.balanceFixedAssets) {
                secondPage.drawText(data.balanceFixedAssets, {
                    x: 235,
                    y: height - 418,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //Kapitał własny łącznie
            if(data.balanceTotalEquityOld) {
                secondPage.drawText(data.balanceTotalEquityOld, {
                    x: 400,
                    y: height - 418,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            if(data.balanceTotalEquity) {
                secondPage.drawText(data.balanceTotalEquity, {
                    x: 470,
                    y: height - 418,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //Rzeczowy majątek trwały
            if(data.balanceBusinesslikeAndDurableOld) {
                secondPage.drawText(data.balanceBusinesslikeAndDurableOld, {
                    x: 165,
                    y: height - 434,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            if(data.balanceBusinesslikeAndDurable) {
                secondPage.drawText(data.balanceBusinesslikeAndDurable, {
                    x: 235,
                    y: height - 434,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //Kapitał podstawowy
            if(data.balanceCoreCapitalOld) {
                secondPage.drawText(data.balanceCoreCapitalOld, {
                    x: 400,
                    y: height - 434,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            if(data.balanceCoreCapital) {
                secondPage.drawText(data.balanceCoreCapital, {
                    x: 470,
                    y: height - 434,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //Aktywa obrotowe
            if(data.balanceAssetsOld) {
                secondPage.drawText(data.balanceAssetsOld, {
                    x: 165,
                    y: height - 450,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            if(data.balanceAssets) {
                secondPage.drawText(data.balanceAssets, {
                    x: 235,
                    y: height - 450,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //Zobowiązania i rezerwy
            if(data.balanceLiabilitiesAndProvisionsOld) {
                secondPage.drawText(data.balanceLiabilitiesAndProvisionsOld, {
                    x: 400,
                    y: height - 450,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            if(data.balanceLiabilitiesAndProvisions) {
                secondPage.drawText(data.balanceLiabilitiesAndProvisions, {
                    x: 470,
                    y: height - 450,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //Zapasy
            if(data.balanceWrestlingOld) {
                secondPage.drawText(data.balanceWrestlingOld, {
                    x: 165,
                    y: height - 466,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            if(data.balanceWrestling) {
                secondPage.drawText(data.balanceWrestling, {
                    x: 235,
                    y: height - 466,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //Zobowiązania długoterminowe
            if(data.balanceLongtermLiabilitiesOld) {
                secondPage.drawText(data.balanceLongtermLiabilitiesOld, {
                    x: 400,
                    y: height - 466,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            if(data.balanceLongtermLiabilities) {
                secondPage.drawText(data.balanceLongtermLiabilities, {
                    x: 470,
                    y: height - 466,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //Należności krótkoterminowe
            if(data.balanceShorttermReceivablesOld) {
                secondPage.drawText(data.balanceShorttermReceivablesOld, {
                    x: 165,
                    y: height - 482,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            if(data.balanceShorttermReceivables) {
                secondPage.drawText(data.balanceShorttermReceivables, {
                    x: 235,
                    y: height - 482,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //Zobowiązania krótkoterminowe
            if(data.balanceCurrentLiabilitiesOld) {
                secondPage.drawText(data.balanceCurrentLiabilitiesOld, {
                    x: 400,
                    y: height - 482,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            if(data.balanceCurrentLiabilities) {
                secondPage.drawText(data.balanceCurrentLiabilities, {
                    x: 470,
                    y: height - 482,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //Środki pieniężne
            if(data.balanceCashOld) {
                secondPage.drawText(data.balanceCashOld, {
                    x: 165,
                    y: height - 498,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            if(data.balanceCash) {
                secondPage.drawText(data.balanceCash, {
                    x: 235,
                    y: height - 498,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //Suma aktywa/pasywa
            if(data.balanceSumOfAssetsLiabilitiesOld) {
                secondPage.drawText(data.balanceSumOfAssetsLiabilitiesOld, {
                    x: 400,
                    y: height - 498,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            if(data.balanceSumOfAssetsLiabilities) {
                secondPage.drawText(data.balanceSumOfAssetsLiabilities, {
                    x: 470,
                    y: height - 498,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //posiadam przeterminowane
            if(data.expiredStatus == "Tak") {
                //zobowiązania
                secondPage.drawText(data.balanceObligations, {
                    x: 80,
                    y: height - 568,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
                //należności
                secondPage.drawText(data.balanceReceivables, {
                    x: 310,
                    y: height - 568,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // posiadane nieruchomosci
            if(data.realEstatesCorporatePrivate == "Tak") {
                secondPage.drawImage(pngImage, {
                    x: 95.8,
                    y: height -613,
                    width: 3.6,
                    height: 3.6,
                })
            }else{
                secondPage.drawImage(pngImage, {
                    x: 74.8,
                    y: height -613,
                    width: 3.6,
                    height: 3.6,
                })
            }
            //hipoteka obciążona
            if(data.realEstatesMortgageEncumbered == "Tak") {
                secondPage.drawImage(pngImage, {
                    x: 247,
                    y: height -613,
                    width: 3.6,
                    height: 3.6,
                })
            }else{
                secondPage.drawImage(pngImage, {
                    x: 226,
                    y: height -613,
                    width: 3.6,
                    height: 3.6,
                })
            }
            //własność
            if(data.realEstatesOwnership == "Firmy") {
                secondPage.drawImage(pngImage, {
                    x: 377,
                    y: height -613,
                    width: 3.6,
                    height: 3.6,
                })
            }else{
                secondPage.drawImage(pngImage, {
                    x: 402.5,
                    y: height -613,
                    width: 3.6,
                    height: 3.6,
                })
            }
            //inne zobowiązania
            for (let u = 0; u < data.otherCreditsItems.length; u++) {
                if(data.otherCreditsItems[u].typeCredit == "Kredyt") {
                    //inne zobowiazania - typ - kredyt
                    secondPage.drawImage(pngImage, {
                        x: 74.8,
                        y: height - 680.6 - (u * 16.2),
                        width: 3.6,
                        height: 3.6,
                    })
                }else if(data.otherCreditsItems[u].typeCredit == "Leasing") {
                    //inne zobowiazania - typ - leasing
                    secondPage.drawImage(pngImage, {
                        x: 101.8,
                        y: height - 680.6 - (u * 16.2),
                        width: 3.6,
                        height: 3.6,
                    })
                }else{
                    //inne zobowiazania - typ - inne
                    secondPage.drawImage(pngImage, {
                        x: 131,
                        y: height - 680.8 - (u * 16.2),
                        width: 3.6,
                        height: 3.6,
                    })
                }
                //inne zobowiazania - opis
                if(data.otherCreditsItems[u].descCredit) {
                    secondPage.drawText(`${data.otherCreditsItems[u].descCredit}`, {
                        x: 159,
                        y: height - 682 - (u * 16.2),
                        size: size,
                        font: customFont,
                        lineHeight: lineHeight,
                        color: colorFont,
                    })
                }
                //inne zobowiazania - kwota do splaty
                if(data.otherCreditsItems[u].priceToEnd) {
                    secondPage.drawText(`${data.otherCreditsItems[u].priceToEnd}`, {
                        x: 304,
                        y: height - 682 - (u * 16.2),
                        size: size,
                        font: customFont,
                        lineHeight: lineHeight,
                        color: colorFont,
                    })
                }
                //inne zobowiazania - kiedy udzielony
                if(data.otherCreditsItems[u].creditStartDate) {
                    secondPage.drawText(`${data.otherCreditsItems[u].creditStartDate}`, {
                        x: 380,
                        y: height - 682 - (u * 16.2),
                        size: size,
                        font: customFont,
                        lineHeight: lineHeight,
                        color: colorFont,
                    })
                }
                //inne zobowiazania - termin splaty
                if(data.otherCreditsItems[u].creditEndDay) {
                    secondPage.drawText(`${data.otherCreditsItems[u].creditEndDay}`, {
                        x: 454,
                        y: height - 682 - (u * 16.2),
                        size: size,
                        font: customFont,
                        lineHeight: lineHeight,
                        color: colorFont,
                    })
                }
            }
            //oswiadczam ze powyzsze zobowiazania sa placone terminowo
            if(data.statementCreditsPaymentCheckbox == "Tak") {
                secondPage.drawImage(pngImage, {
                    x: 230.2,
                    y: height - 729.4,
                    width: 3.6,
                    height: 3.6,
                })
            }else if(data.statementCreditsPaymentCheckbox == "Nie") {
                secondPage.drawImage(pngImage, {
                    x: 209.2,
                    y: height - 729.4,
                    width: 3.6,
                    height: 3.6,
                })
            }
            //zgody
            if(data.authCheckThree) {
                thirdPage.drawImage(pngImage, {
                    x: 71.8,
                    y: height - 307.2,
                    width: 3.6,
                    height: 3.6,
                })
            }
            if(data.authCheckFour) {
                thirdPage.drawImage(pngImage, {
                    x: 71.8,
                    y: height - 316.2,
                    width: 3.6,
                    height: 3.6,
                })
            }

            if(data.authCheckFive) {
                thirdPage.drawImage(pngImage, {
                    x: 71.8,
                    y: height - 361.2,
                    width: 3.6,
                    height: 3.6,
                })
            }
            if(data.authCheckSix) {
                thirdPage.drawImage(pngImage, {
                    x: 71.8,
                    y: height - 370.2,
                    width: 3.6,
                    height: 3.6,
                })
            }

            //weryfikacja osob fizycznych
            // [0]
            if(data.registryType == "CEIDG") {
                if(data.representatives[0]) {
                    //imie 1
                    thirdPage.drawText(`${data.representatives[0].name} ${data.representatives[0].surname}`, {
                        x: 130,
                        //   y: height - 480,
                        y: height - 504,
                        size: size,
                        font: customFont,
                        lineHeight: lineHeight,
                        color: colorFont,
                    })
                    //address
                    thirdPage.drawText(`${data.representatives[0].address}`, {
                        x: 130,
                        y: height - 519.5,
                        size: size,
                        font: customFont,
                        lineHeight: lineHeight,
                        color: colorFont,
                    })
                    //pesel
                    for (let i = 0; i < (data.representatives[0].pesel).length; i++) {
                        thirdPage.drawText(`${data.representatives[0].pesel[i]}`, {
                            x: 130 + (i * 9),
                            y: height - 535,
                            size: size,
                            font: customFont,
                            lineHeight: lineHeight,
                            color: colorFont,
                        })
                    }
                    //dow osobisty seria i nr
                    for (let i = 0; i < data.representatives[0].id.length; i++) {
                        if(i < 9) {
                            thirdPage.drawText(`${data.representatives[0].id[i]}`, {
                                x: 130 + (i * 9),
                                y: height - 550,
                                size: size,
                                font: customFont,
                                lineHeight: lineHeight,
                                color: colorFont,
                            })
                        }
                    }
                    //stan cywilny
                    if(data.representatives[0].maritalStatus == 'Wolny') {
                        thirdPage.drawImage(pngImage, {
                            // x: 130,
                            x: 110.8,
                            y: height - 567.8,
                            width: 3.6,
                            height: 3.6,
                        })
                    }else if(data.representatives[0].maritalStatus == 'Współmałżonek — rodzielność majątkowa') {
                        thirdPage.drawImage(pngImage, {
                            x: 137.8,
                            y: height - 567.8,
                            width: 3.6,
                            height: 3.6,
                        })
                    }else if(data.representatives[0].maritalStatus == 'Współmałżonek — wspólnota majątkowa') {
                        thirdPage.drawImage(pngImage, {
                            x: 110.8,
                            y: height - 575.8,
                            width: 3.6,
                            height: 3.6,
                        })
                    }
                }
                // [1]
                if(data.representatives[1]) {
                    //imie 2
                    thirdPage.drawText(`${data.representatives[1].name} ${data.representatives[1].surname}`, {
                        x: 364,
                        y: height - 504,
                        size: size,
                        font: customFont,
                        lineHeight: lineHeight,
                        color: colorFont,
                    })
                    //address
                    thirdPage.drawText(`${data.representatives[1].address}`, {
                        x: 364,
                        y: height - 519.5,
                        size: size,
                        font: customFont,
                        lineHeight: lineHeight,
                        color: colorFont,
                    })
                    //pesel
                    for (let i = 0; i < (data.representatives[1].pesel).length; i++) {
                        thirdPage.drawText(`${data.representatives[1].pesel[i]}`, {
                            x: 364 + (i * 9),
                            y: height - 535,
                            size: size,
                            font: customFont,
                            lineHeight: lineHeight,
                            color: colorFont,
                        })
                    }
                    //dow osobisty seria i nr
                    for (let i = 0; i < data.representatives[1].id.length; i++) {
                        if(i < 9) {
                            thirdPage.drawText(`${data.representatives[1].id[i]}`, {
                                x: 364 + (i * 9),
                                y: height - 550,
                                size: size,
                                font: customFont,
                                lineHeight: lineHeight,
                                color: colorFont,
                            })
                        }
                    }
                    //stan cywilny
                    if(data.representatives[1].maritalStatus == 'Wolny') {
                        thirdPage.drawImage(pngImage, {
                            x: 344.8,
                            y: height - 567.6,
                            width: 3.6,
                            height: 3.6,
                        })
                    }else if(data.representatives[1].maritalStatus == 'Współmałżonek — rodzielność majątkowa') {
                        thirdPage.drawImage(pngImage, {
                            x: 371.6,
                            y: height - 567.8,
                            width: 3.6,
                            height: 3.6,
                        })
                    }else if(data.representatives[0].maritalStatus == 'Współmałżonek — wspólnota majątkowa') {
                        thirdPage.drawImage(pngImage, {
                            x: 344.8,
                            y: height - 576,
                            width: 3.6,
                            height: 3.6,
                        })
                    }
                }
            }
        }else{
            //OD 200K
            //Pełna nazwa firmy
            if(data.companyInfo) {
                firstPage.drawText(data.companyInfo, {
                    x: 86,
                    y: height - 220,
                    size: size,
                    font: customFont,
                    lineHeight: 6,
                    color: colorFont,
                })
            }
            // //tel
            if(data.companyPhone) {
                firstPage.drawText(data.companyPhone, {
                    x: 86,
                    y: height - 271,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // //www
            if(data.companyWWW && data.companyWWW.length > 0) {
                firstPage.drawText(data.companyWWW, {
                    x: 200,
                    y: height - 271,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // //email
            if(data.companyEmail) {
                firstPage.drawText(data.companyEmail, {
                    x: 120,
                    y: height - 287.5,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // //email
            if(data.emailInvoice) {
                firstPage.drawText(data.emailInvoice, {
                    x: 150,
                    y: height - 305,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // //dodatkowy kod pocztowy
            if(data.additionalPostal) {
                firstPage.drawText(data.additionalPostal, {
                    x: 346,
                    y: height - 356.5,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // //dodatkowe miasto
            if(data.additionalCity) {
                firstPage.drawText(data.additionalCity, {
                    x: 332,
                    y: height - 372.5,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }

            // //dodatkowy Adres
            if(data.additionalAddress) {
                firstPage.drawText(data.additionalAddress, {
                    x: 90,
                    y: height - 372.5,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // //data rozpoczecia dzialalnosci
            if(data.companyCreatedDate.day) {
                firstPage.drawText(data.companyCreatedDate.day, {
                    x: 427,
                    y: height - 221,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // //data rozpoczecia dzialalnosci
            if(data.companyCreatedDate.month) {
                firstPage.drawText(data.companyCreatedDate.month, {
                    x: 444,
                    y: height - 221,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // //data rozpoczecia dzialalnosci
            if(data.companyCreatedDate.year) {
                firstPage.drawText(data.companyCreatedDate.year, {
                    x: 461,
                    y: height - 221,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // //liczba pracownikow
            if(data.employeesNumber) {
                firstPage.drawText(data.employeesNumber, {
                    x: 360,
                    y: height - 237.5,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //branza
            if(data.profession && data.profession.length > 0) {
                firstPage.drawText(data.profession, {
                    x: 366,
                    y: height - 254.5,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //krs/inny rejestr
            if(data.krs && data.krs.length > 0) {
                firstPage.drawText(data.krs, {
                    x: 353,
                    y: height - 271,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // //nip
            if(data.nip) {
                firstPage.drawText(data.nip, {
                    x: 430,
                    y: height - 271,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            // //dane osob upowaznionych
            if(data.representatives) {
                for (let x = 0; x < data.representatives.length; x++) {
                    //imie
                    if(data.representatives[x].name) {
                        firstPage.drawText(`${data.representatives[x].name} ${data.representatives[x].surname}`, {
                            x: 75,
                            y: height - 433 - (x * 64),
                            size: size,
                            font: customFont,
                            lineHeight: lineHeight,
                            color: colorFont,
                        })
                    }
                    //pesel
                    if(data.representatives[x].pesel) {
                        for (let i = 0; i < (data.representatives[x].pesel).length; i++) {
                            firstPage.drawText(`${data.representatives[x].pesel[i]}`, {
                                x: 195 + (i * 9),
                                y: height - 433 - (x * 63),
                                size: size,
                                font: customFont,
                                lineHeight: lineHeight,
                                color: colorFont,
                            })
                        }
                    }
                    //obywatelstwo
                    if(data.representatives[x].citizenship) {
                        firstPage.drawText(`${data.representatives[x].citizenship}`, {
                            x: 310,
                            y: height - 433 - (x * 64),
                            size: size,
                            font: customFont,
                            lineHeight: lineHeight,
                            color: colorFont,
                        })
                    }
                    //państwo urodzenia 
                    if(data.representatives[x].countryBirth) {
                        firstPage.drawText(`${data.representatives[x].countryBirth}`, {
                            x: 420,
                            y: height - 433 - (x * 64),
                            size: size,
                            font: customFont,
                            lineHeight: lineHeight,
                            color: colorFont,
                        })
                    }
                    //dokument
                    if(data.representatives[x].document == "Inny (np. karta pobytu)") {
                        firstPage.drawImage(pngImage, {
                            x: 187.2,
                            y: height - 451.5 - (x * 64),
                            width: 3.6,
                            height: 3.6,
                        })
                    }else if(data.representatives[x].document == "Paszport") {
                        firstPage.drawImage(pngImage, {
                            x: 154.8,
                            y: height - 451.5 - (x * 64),
                            width: 3.6,
                            height: 3.6,
                        })
                    }else if(data.representatives[x].document == "Dowód osobisty") {
                        firstPage.drawImage(pngImage, {
                            x: 107.2,
                            y: height - 451.5 - (x * 64),
                            width: 3.6,
                            height: 3.6,
                        })
                    }
                    //dow osobisty seria i nr
                    if(data.representatives[x].id) {
                        for (let i = 0; i < data.representatives[x].id.length; i++) {
                            firstPage.drawText(`${data.representatives[x].id}`, {
                                x: 258,
                                y: height - 451 - (x * 64),
                                size: size,
                                font: customFont,
                                lineHeight: lineHeight,
                                color: colorFont,
                            })
                        }
                    }
                    // //data wydania dowodu
                    if(data.representatives[x].idReleaseDate) {
                        firstPage.drawText(`${data.representatives[x].idReleaseDate}`, {
                            x: 366,
                            y: height - 451.3 - (x * 64),
                            size: size,
                            font: customFont,
                            lineHeight: lineHeight,
                            color: colorFont,
                        })
                    }
                    // //data waznosci dowodu
                    if(data.representatives[x].idExpirationDate) {
                        firstPage.drawText(`${data.representatives[x].idExpirationDate}`, {
                            x: 456,
                            y: height - 451.3 - (x * 64),
                            size: size,
                            font: customFont,
                            lineHeight: lineHeight,
                            color: colorFont,
                        })
                    }
                }
            }
            // //ZOBOWIĄZANIA PUBLICZNOPRAWNE 
            // Zaległości podatkowe - nie
            if(data.taxArrears == "Nie") {
                firstPage.drawImage(pngImage, {
                    x: 226,
                    y: height - 562, 
                    width: 3.6,
                    height: 3.6,
                })
            }else if(data.taxArrears == "Tak") {
                // Zaległości podatkowe - tak
                firstPage.drawImage(pngImage, {
                    x: 247,
                    y: height - 562.2, 
                    width: 3.6,
                    height: 3.6,
                })
                // Zaległości podatkowe - kwota
                if(data.taxArrearsPrice) {
                    firstPage.drawText(data.taxArrearsPrice, {
                        x: 392,
                        y: height - 562, 
                        size: size,
                        font: customFont,
                        lineHeight: lineHeight,
                        color: colorFont,
                    })
                }
            }
            if(data.ZUSarrears == "Nie") {
                // // Zaległości wobec ZUS - nie
                firstPage.drawImage(pngImage, {
                    x: 226,
                    y: height - 579, 
                    width: 3.6,
                    height: 3.6,
                })
            }else if(data.ZUSarrears == "Tak") {
                // Zaległości wobec ZUS - tak
                firstPage.drawImage(pngImage, {
                    x: 247,
                    y: height - 579.2, 
                    width: 3.6,
                    height: 3.6,
                })
                // Zaległości wobec ZUS - kwota
                if(data.ZUSarrearsPrice) {
                    firstPage.drawText(data.ZUSarrearsPrice, {
                        x: 392,
                        y: height - 579.2, 
                        size: size,
                        font: customFont,
                        lineHeight: lineHeight,
                        color: colorFont,
                    })
                }
            }
            if(data.enforcementProceedings == "Nie") {
                // Czy jest prowadzone postępowanie - nie
                firstPage.drawImage(pngImage, {
                    x: 226,
                    y: height - 595, 
                    width: 3.6,
                    height: 3.6,
                })
            }else if(data.enforcementProceedings == "Tak") {
                // Czy jest prowadzone postępowanie - tak
                firstPage.drawImage(pngImage, {
                    x: 247,
                    y: height - 595.2, 
                    width: 3.6,
                    height: 3.6,
                })
                // Czy jest prowadzone postępowanie - kwota
                if(data.enforcementProceedingsPrice) {
                    firstPage.drawText(data.ZUSarrearsPrice, {
                        x: 392,
                        y: height - 595, 
                        size: size,
                        font: customFont,
                        lineHeight: lineHeight,
                        color: colorFont,
                    })
                }
            }
            //posiadane nieruchomosci
            if(data.realEstatesItems) {
                for (let s = 0; s < data.realEstatesItems.length; s++) {
                    // posiadane nieruchomosci - opis
                    if(data.realEstatesItems[s].name) {
                        firstPage.drawText(`${data.realEstatesItems[s].name}`, {
                            x: 75,
                            y: height - 683 - (s * 16),
                            size: size,
                            font: customFont,
                            lineHeight: lineHeight,
                            color: colorFont,
                        })
                    }
                    // posiadane nieruchomosci - address
                    if(data.realEstatesItems[s].address) {
                        firstPage.drawText(`${data.realEstatesItems[s].address}`, {
                            x: 154,
                            y: height - 683 - (s * 16),
                            size: size,
                            font: customFont,
                            lineHeight: lineHeight,
                            color: colorFont,
                        })
                    }
                    // posiadane nieruchomosci - wartosc rynkowa
                    if(data.realEstatesItems[s].price) {
                        firstPage.drawText(`${data.realEstatesItems[s].price}`, {
                            x: 281,
                            y: height - 683 - (s * 16),
                            size: size,
                            font: customFont,
                            lineHeight: lineHeight,
                            color: colorFont,
                        })
                    }
                    if(data.realEstatesItems[s].credit == "Nie") {
                        // posiadane nieruchomosci - hipoteka obciazona - nie
                        firstPage.drawImage(pngImage, {
                            x: 338.3,
                            y: height - 683 - (s * 16.2),
                            width: 3.6,
                            height: 3.6,
                        })
                    }else{
                        // posiadane nieruchomosci - hipoteka obciazona - tak
                        firstPage.drawImage(pngImage, {
                            x: 359.3,
                            y: height - 683 - (s * 16.2),
                            width: 3.6,
                            height: 3.6,
                        })
                    }
                    if(data.realEstatesItems[s].property == "Firmy") {
                        // posiadane nieruchomosci - wlasnosc - firmy
                        firstPage.drawImage(pngImage, {
                            x: 395.1,
                            y: height - 683 - (s * 16.2),
                            width: 3.6,
                            height: 3.6,
                        })
                    }else{
                        // posiadane nieruchomosci - wlasnosc - prywatna
                        firstPage.drawImage(pngImage, {
                            x: 420.3,
                            y: height - 683 - (s * 16.2),
                            width: 3.6,
                            height: 3.6,
                        })
                    }
                    if(data.realEstatesItems[s].kw) {
                        firstPage.drawText(`${data.realEstatesItems[s].kw}`, {
                            x: 461,
                            y: height - 683 - (s * 15.1),
                            size: size,
                            font: customFont,
                            lineHeight: lineHeight,
                            color: colorFont,
                        })
                    }
                    //inne zobowiązania
                    for (let u = 0; u < data.otherCreditsItems.length; u++) {
                        if(data.otherCreditsItems[u].typeCredit == "Kredyt") {
                            //inne zobowiazania - typ - kredyt
                            secondPage.drawImage(pngImage, {
                                x: 74.8,
                                y: height - 195 - (u * 16.1),
                                width: 3.6,
                                height: 3.6,
                            })
                        }else if(data.otherCreditsItems[u].typeCredit == "Leasing") {
                            //inne zobowiazania - typ - leasing
                            secondPage.drawImage(pngImage, {
                                x: 101.8,
                                y: height - 195 - (u * 16.1),
                                width: 3.6,
                                height: 3.6,
                            })
                        }else{
                            //inne zobowiazania - typ - inne
                            secondPage.drawImage(pngImage, {
                                x: 131,
                                y: height - 195 - (u * 16.1),
                                width: 3.6,
                                height: 3.6,
                            })
                        }
                        //inne zobowiazania - opis
                        if(data.otherCreditsItems[u].descCredit) {
                            secondPage.drawText(`${data.otherCreditsItems[u].descCredit}`, {
                                x: 162,
                                y: height - 195 - (u * 15.1),
                                size: size,
                                font: customFont,
                                lineHeight: lineHeight,
                                color: colorFont,
                            })
                        }
                        //inne zobowiazania - kwota do splaty
                        if(data.otherCreditsItems[u].priceToEnd) {
                            secondPage.drawText(`${data.otherCreditsItems[u].priceToEnd}`, {
                                x: 307,
                                y: height - 195 - (u * 15.1),
                                size: size,
                                font: customFont,
                                lineHeight: lineHeight,
                                color: colorFont,
                            })
                        }
                        //inne zobowiazania - kiedy udzielony
                        if(data.otherCreditsItems[u].creditStartDate) {
                            secondPage.drawText(`${data.otherCreditsItems[u].creditStartDate}`, {
                                x: 380,
                                y: height - 195 - (u * 15.1),
                                size: size,
                                font: customFont,
                                lineHeight: lineHeight,
                                color: colorFont,
                            })
                        }
                        //inne zobowiazania - termin splaty
                        if(data.otherCreditsItems[u].creditEndDay) {
                            secondPage.drawText(`${data.otherCreditsItems[u].creditEndDay}`, {
                                x: 454,
                                y: height - 195 - (u * 15.1),
                                size: size,
                                font: customFont,
                                lineHeight: lineHeight,
                                color: colorFont,
                            })
                        }
                    }
                }
            }
            //oswiadczam ze powyzsze zobowiazania sa placone terminowo
            if(data.statementCreditsPaymentCheckbox == "Tak") {
                secondPage.drawImage(pngImage, {
                    x: 230.4,
                    y: height - 259.8,
                    width: 3.6,
                    height: 3.6,
                })
            }else if(data.statementCreditsPaymentCheckbox == "Nie") {
                secondPage.drawImage(pngImage, {
                    x: 209.4,
                    y: height - 259.8,
                    width: 3.6,
                    height: 3.6,
                })
            }
            //zobowiązania i należności z tytułu dostaw i usług
            //stan na dzien
            if(data.receivablesObligationsDeliveriesServicesDate) {
                secondPage.drawText(`${data.receivablesObligationsDeliveriesServicesDate}`, {
                    x: 460,
                    y: height - 286,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //Kwota zobowiązań ogółem
            if(data.obligationsTotalPrice) {
                secondPage.drawText(`${data.obligationsTotalPrice}`, {
                    x: 80,
                    y: height - 302,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //Ostateczny termin zapłaty
            if(data.obligationsLastDatePay) {
                secondPage.drawText(`${data.obligationsLastDatePay}`, {
                    x: 170,
                    y: height - 302,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //Liczba wierzycieli
            if(data.obligationsNumberCreditors) {
                secondPage.drawText(`${data.obligationsNumberCreditors}`, {
                    x: 235,
                    y: height - 302,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //W tym zobowiązania przeterminowane
            if(data.obligationsOverdueLiabilities) {
                secondPage.drawText(`${data.obligationsOverdueLiabilities}`, {
                    x: 300,
                    y: height - 302,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //Zobowiązania przeterminowane > 30 dni
            if(data.obligationsOverdueLiabilitiesOver30Days) {
                secondPage.drawText(`${data.obligationsOverdueLiabilitiesOver30Days}`, {
                    x: 415,
                    y: height - 302,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //kolejny wiersz
            //Kwota należności ogółem
            if(data.receivablesTotalPrice) {
                secondPage.drawText(`${data.receivablesTotalPrice}`, {
                    x: 80,
                    y: height - 327,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //Ostateczny termin zapłaty
            if(data.receivablesLastDatePay) {
                secondPage.drawText(`${data.receivablesLastDatePay}`, {
                    x: 170,
                    y: height - 327,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //Liczba dłużników
            if(data.receivablesNumberCreditors) {
                secondPage.drawText(`${data.receivablesNumberCreditors}`, {
                    x: 235,
                    y: height - 327,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //W tym należności przeterminowane
            if(data.receivablesOverdueLiabilities) {
                secondPage.drawText(`${data.receivablesOverdueLiabilities}`, {
                    x: 300,
                    y: height - 327,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //Należności przeterminowane > 30 dni
            if(data.receivablesOverdueLiabilitiesOver30Days) {
                secondPage.drawText(`${data.receivablesOverdueLiabilitiesOver30Days}`, {
                    x: 415,
                    y: height - 327,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //Wyjaśnienie zobowiązań i należności przeterminowanych
            if(data.explanationReceivablesObligations) {
                secondPage.drawText(`${data.explanationReceivablesObligations}`, {
                    x: 80,
                    y: height - 375,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //Wyjaśnienie straty (jeśli występowała w ostatnich 2 latach)
            if(data.explanationLoss) {
                secondPage.drawText(`${data.explanationLoss}`, {
                    x: 80,
                    y: height - 465,
                    size: size,
                    font: customFont,
                    lineHeight: lineHeight,
                    color: colorFont,
                })
            }
            //zgody
            if(data.authCheckThree) {
                thirdPage.drawImage(pngImage, {
                    x: 71.8,
                    y: height - 307.2,
                    width: 3.6,
                    height: 3.6,
                })
            }
            if(data.authCheckFour) {
                thirdPage.drawImage(pngImage, {
                    x: 71.8,
                    y: height - 316.2,
                    width: 3.6,
                    height: 3.6,
                })
            }
            if(data.authCheckFive) {
                thirdPage.drawImage(pngImage, {
                    x: 71.8,
                    y: height - 361.2,
                    width: 3.6,
                    height: 3.6,
                })
            }
            if(data.authCheckSix) {
                thirdPage.drawImage(pngImage, {
                    x: 71.8,
                    y: height - 370.2,
                    width: 3.6,
                    height: 3.6,
                })
            }
            //weryfikacja osob fizycznych
            // [0]
            if(data.registryType == "CEIDG") {
                if(data.representatives[0]) {
                    //imie 1
                    thirdPage.drawText(`${data.representatives[0].name} ${data.representatives[0].surname}`, {
                        x: 130,
                        //   y: height - 480,
                        y: height - 504,
                        size: size,
                        font: customFont,
                        lineHeight: lineHeight,
                        color: colorFont,
                    })
                    //address
                    thirdPage.drawText(`${data.representatives[0].address}`, {
                        x: 130,
                        y: height - 519.5,
                        size: size,
                        font: customFont,
                        lineHeight: lineHeight,
                        color: colorFont,
                    })
                    //pesel
                    for (let i = 0; i < (data.representatives[0].pesel).length; i++) {
                        thirdPage.drawText(`${data.representatives[0].pesel[i]}`, {
                            x: 130 + (i * 9),
                            y: height - 535,
                            size: size,
                            font: customFont,
                            lineHeight: lineHeight,
                            color: colorFont,
                        })
                    }
                    //dow osobisty seria i nr
                    for (let i = 0; i < data.representatives[0].id.length; i++) {
                        if(i < 9) {
                            thirdPage.drawText(`${data.representatives[0].id[i]}`, {
                                x: 130 + (i * 9),
                                y: height - 550,
                                size: size,
                                font: customFont,
                                lineHeight: lineHeight,
                                color: colorFont,
                            })
                        }
                    }
                    //stan cywilny
                    if(data.representatives[0].maritalStatus == 'Wolny') {
                        thirdPage.drawImage(pngImage, {
                            // x: 130,
                            x: 110.8,
                            y: height - 567.8,
                            width: 3.6,
                            height: 3.6,
                        })
                    }else if(data.representatives[0].maritalStatus == 'Współmałżonek — rodzielność majątkowa') {
                        thirdPage.drawImage(pngImage, {
                            x: 137.8,
                            y: height - 567.8,
                            width: 3.6,
                            height: 3.6,
                        })
                    }else if(data.representatives[0].maritalStatus == 'Współmałżonek — wspólnota majątkowa') {
                        thirdPage.drawImage(pngImage, {
                            x: 110.8,
                            y: height - 575.8,
                            width: 3.6,
                            height: 3.6,
                        })
                    }
                }
                // [1]
                if(data.representatives[1]) {
                    //imie 2
                    thirdPage.drawText(`${data.representatives[1].name} ${data.representatives[1].surname}`, {
                        x: 364,
                        y: height - 504,
                        size: size,
                        font: customFont,
                        lineHeight: lineHeight,
                        color: colorFont,
                    })
                    //address
                    thirdPage.drawText(`${data.representatives[1].address}`, {
                        x: 364,
                        y: height - 519.5,
                        size: size,
                        font: customFont,
                        lineHeight: lineHeight,
                        color: colorFont,
                    })
                    //pesel
                    for (let i = 0; i < (data.representatives[1].pesel).length; i++) {
                        thirdPage.drawText(`${data.representatives[1].pesel[i]}`, {
                            x: 364 + (i * 9),
                            y: height - 535,
                            size: size,
                            font: customFont,
                            lineHeight: lineHeight,
                            color: colorFont,
                        })
                    }
                    //dow osobisty seria i nr
                    for (let i = 0; i < data.representatives[1].id.length; i++) {
                        if(i < 9) {
                            thirdPage.drawText(`${data.representatives[1].id[i]}`, {
                                x: 364 + (i * 9),
                                y: height - 550,
                                size: size,
                                font: customFont,
                                lineHeight: lineHeight,
                                color: colorFont,
                            })
                        }
                    }
                    //stan cywilny
                    if(data.representatives[1].maritalStatus == 'Wolny') {
                        thirdPage.drawImage(pngImage, {
                            x: 344.8,
                            y: height - 567.6,
                            width: 3.6,
                            height: 3.6,
                        })
                    }else if(data.representatives[1].maritalStatus == 'Współmałżonek — rodzielność majątkowa') {
                        thirdPage.drawImage(pngImage, {
                            x: 371.6,
                            y: height - 567.8,
                            width: 3.6,
                            height: 3.6,
                        })
                    }else if(data.representatives[0].maritalStatus == 'Współmałżonek — wspólnota majątkowa') {
                        thirdPage.drawImage(pngImage, {
                            x: 344.8,
                            y: height - 576,
                            width: 3.6,
                            height: 3.6,
                        })
                    }
                }
            }
            //koniec 200k
        }

    } 


    // const pdfBytes = await pdfDoc.save()
    const pdfDataUri = await pdfDoc.saveAsBase64({ dataUri: true });
    // if (typeof window !== "undefined") {
    //     let link = window.open("");
    //     if (link) {
    //         link.document.write(
    //             `<iframe width='100%' height='100%' src='${encodeURI(pdfDataUri)}'></iframe>`
    //         )
    //     }
    // }

    const downloadLink = document.createElement("a");
    const fileName = "wniosek-grenke.pdf";
    downloadLink.href = encodeURI(pdfDataUri);
    downloadLink.download = fileName;
    downloadLink.click();
    return true;
}

export default drawPDF;